import { Component, OnInit } from '@angular/core';
import { CurrentUserStateService } from '../../services/current-user-state.service';

@Component({
    selector: 'app-logout-idle-dialog',
    templateUrl: './logout-idle-dialog.component.html',
    styleUrls: ['./logout-idle-dialog.component.css'],
})
export class LogoutIdleDialogComponent implements OnInit {
    constructor(public currentUser: CurrentUserStateService) {}

    ngOnInit(): void {}
}
